<template>
<div class="popup_overlay">
  <div class="custom_dialog_comp bg-white h-full" style="width:100%">
    <div class="cust_card_comp">
      <div class=" rounded px-5 py-4 h-full bg-primary text-white heading-2 font-bold flex items-center justify-between">
        <div>
          <p class="">faqs_group</p>
        </div>
        <div>
          <button class="list_top_card_btn font-bold bg-gray-200 cta-text text-text1 py-2 px-4 mr-2 rounded-3xl" @click="closeDetails(false)">Discard</button>
          <button class="list_top_card_btn font-bold  bg-success cta-text text-white py-2 px-4 rounded-3xl" @click="saveData()">Save</button>
        </div>  
      </div>
  <div class="p-0 bg-white" >
    <div class="bg-white p-2">
      <div class="pt-2 px-1 grid grid-cols-2 gap-x-2">
        <div class="box bg-white h-full cust_card">
          <div>
            <!-- <div class="p-2 pb-0 grid grid-cols-12">
              <div class="box col-span-6 p-2 pb-0">
                <p class="label_css">heading</p>
                <input v-model="fieldJsonData.heading"
                :class="heading_err ? 'border border-error' : ''"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="heading"
                >
                <p v-if="heading_err" class="text-error heading-6">heading is required</p>
              </div>
              <div class="box col-span-6 p-2 pb-0">
                <p class="label_css">description</p>
                <textarea v-model="fieldJsonData.description"
                :class="desc_err ? 'border border-error' : ''"
                class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                placeholder="description"
                ></textarea>
                <p v-if="desc_err" class="text-error heading-6">description is required</p>
              </div>
            </div>
            <div  class="mt-4" style="border: 1px solid gray"></div>  -->
          <div class="py-2 px-1 grid  gap-x-2">
            <p class="label_css pl-2 font-bold">tab_list</p>
           <div v-for="(data, index) in fieldJsonData.tab_list" :key="index" class="p-2 pb-0 grid grid-cols-12">
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">comp_slug</p>
                    <input v-model="data.comp_slug"
                    :class="tab_list_errorArray[index].comp_slug_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="comp_slug"
                    >
                    <p v-if="tab_list_errorArray[index].comp_slug_err" class="text-error heading-6">comp_slug is required</p>
                </div>
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">heading</p>
                    <textarea v-model="data.heading"
                    :class="tab_list_errorArray[index].heading_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="heading"
                    ></textarea>
                    <p v-if="tab_list_errorArray[index].heading_err" class="text-error heading-6">heading is required</p>
                </div>
                <!-- <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">description</p>
                    <textarea v-model="data.description"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="description"
                    ></textarea>
                </div> -->
                <div class="box col-span-12 p-1 mt-3">
                <div class="flex justify-end">
                  <button v-if="index !== 0" class=" rounded-full h-8 w-8 bg-error  mr-1"
                    @click="removeTabListDetails(index)"
                    >
                    <i class="fas fa-minus text-white heading-3"></i>
                  </button>
                  <button v-if="index === fieldJsonData.tab_list.length - 1" class=" rounded-full h-8 w-8 bg-primary"
                  @click="addTabListDetails()"
                    >
                    <i class="fas fa-plus text-white heading-3"></i>
                  </button>
                </div>
              </div>
                <div v-if="fieldJsonData.tab_list.length - 1 !== index" class="mt-4 col-span-12" style="border: 1px solid gray; border-style: dashed"></div>
             </div>
          </div>
              <div  class="mt-4" style="border: 1px solid gray"></div> 
          </div>
          <div class="py-2 px-1 grid  gap-x-2">
            <p class="label_css pl-2 font-bold">tab_content_list</p>
           <div v-for="(data, index) in fieldJsonData.tab_content_list" :key="index" class="p-2 pb-0 grid grid-cols-12">
                <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">comp_slug</p>
                    <input v-model="data.comp_slug"
                    :class="tab_content_list_errorArray[index].comp_slug_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="comp_slug"
                    >
                    <p v-if="tab_content_list_errorArray[index].comp_slug_err" class="text-error heading-6">comp_slug is required</p>
                </div>
                <div class="box col-span-12 p-2 pb-0">
                    <p class="label_css">faq_question</p>
                    <textarea v-model="data.faq_question"
                    :class="tab_content_list_errorArray[index].faq_question_err ? 'border border-error' : ''"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="faq_question"
                    ></textarea>
                    <p v-if="tab_content_list_errorArray[index].faq_question_err" class="text-error heading-6">faq_question is required</p>
                </div>
                <div v-if="tempCardDescriptionIndex !== index" class="box col-span-12 p-2 pb-0" :class="componentDetailsForEdit !== null ? '' : 'mt-4'">
                <label class="label_css font-bold cursor-pointer" style="color: #1976D3" @click="openCardListDescription(index)">{{componentDetailsForEdit !== null ? "+ Edit faq_answer_detail" : "+ Add faq_answer_detail"}}</label>
                <p v-if="componentDetailsForEdit !== null" v-html="data.faq_answer_detail"></p>
                <p v-if="tab_content_list_errorArray[index].faq_answer_detail_err" class="text-error heading-6">faq_answer_detail is required</p>
                </div>
                <div v-if="tempCardDescriptionIndex === index && cardDescriptionEditor === false" class="box col-span-12 p-2 pb-0">
                    <p class="label_css">faq_answer_detail</p>
                    <editor v-model="data.faq_answer_detail"
                    :class="tab_content_list_errorArray[index].faq_answer_detail_err ? 'border border-error' : ''"
                    placeholder="faq_answer_detail"
                    ></editor>
                    <p v-if="tab_content_list_errorArray[index].faq_answer_detail_err" class="text-error heading-6">faq_answer_detail is required</p>
                </div>
                <!-- <div class="box col-span-6 p-2 pb-0">
                    <p class="label_css">additional_data</p>
                    <textarea v-model="data.additional_data"
                    class="outline-none  text-gray-900 text-sm rounded  block w-full pl-2 p-2.5 h-12 heading-4 border border-gray-500 focus:border-gray-800" 
                    placeholder="additional_data"
                    ></textarea>
                </div> -->
                <div class="box col-span-12 p-1 mt-3">
                <div class="flex justify-end">
                  <button v-if="index !== 0" class=" rounded-full h-8 w-8 bg-error  mr-1"
                    @click="removeTabContentDetails(index)"
                    >
                    <i class="fas fa-minus text-white heading-3"></i>
                  </button>
                  <button v-if="index === fieldJsonData.tab_content_list.length - 1" class=" rounded-full h-8 w-8 bg-primary"
                  @click="addTabContentDetails()"
                    >
                    <i class="fas fa-plus text-white heading-3"></i>
                  </button>
                </div>
                </div>
                <div v-if="fieldJsonData.tab_content_list.length - 1 !== index" class="mt-4 col-span-12" style="border: 1px solid gray; border-style: dashed"></div>
             </div>
          </div>
          <!-- <div class="p-2 pb-5 text-right">
            <div>
              <button class="list_top_card_btn bg-gray-200 cta-text text-text1 py-2 px-4 mr-2 rounded-3xl">Discard</button>
              <button class="list_top_card_btn bg-primary cta-text text-white py-2 px-4 mr-2 rounded-3xl" @click="saveData()">Save</button>
            </div>  
          </div> -->
        </div>
        <div>
        <img style="padding: 1px"  class="box border-1 shadow-lg rounded-lg" :src="componentImageUrl" :alt="componentImageUrl" />
      </div>
      </div>
    </div>
  </div>
    </div>
  </div>
</div>
</template>
<script>
import Editor from '../../../../../../components/editor.vue'
// import draggable from 'vuedraggable'
// import HRM from '@/View/CMS/api/HRM.js'
export default {
  components: {
    Editor
    // draggable,
  },
  props: ['componentDetailsForEdit', 'fieldJsonData', 'componentImageUrl', 'componentId'],
  data () {
    return {
      desc_err: false,
      heading_err: false,
      isError: true,
      cardDescriptionEditor: false,
      tempCardDescriptionIndex: null,
      // fieldJsonData: {
      //   component_name: "fieldJsonData_group",
      //   heading: "",
      //   description: "",
      //   tab_list: [
      //       {
      //       comp_slug: "",
      //       comp_slug_err: false,
      //       description: null,
      //       heading: "",
      //       heading_err: false
      //       },
      //       {
      //       comp_slug: "",
      //       comp_slug_err: false,
      //       description: null,
      //       heading: "",
      //       heading_err: false
      //       },
      //       {
      //       comp_slug: "",
      //       comp_slug_err: false,
      //       description: null,
      //       heading: "",
      //       heading_err: false
      //       }
      //   ],
      //   tab_content_list: [
      //       {
      //       comp_slug: "",
      //       comp_slug_err: false,
      //       faq_question: "",
      //       faq_question_err: false,
      //       faq_answer_detail: "",
      //       faq_answer_detail_err: false,
      //       additional_data: ""
      //       },
      //       {
      //       comp_slug: "",
      //       comp_slug_err: false,
      //       faq_question: "",
      //       faq_question_err: false,
      //       faq_answer_detail: "",
      //       faq_answer_detail_err: false,
      //       additional_data: ""
      //       },
      //       {
      //       comp_slug: "",
      //       comp_slug_err: false,
      //       faq_question: "",
      //       faq_question_err: false,
      //       faq_answer_detail: "",
      //       faq_answer_detail_err: false,
      //       additional_data: ""
      //       },
      //       {
      //       comp_slug: "",
      //       comp_slug_err: false,
      //       faq_question: "",
      //       faq_question_err: false,
      //       faq_answer_detail: "",
      //       faq_answer_detail_err: false,
      //       additional_data: ""
      //       },
      //       {
      //       comp_slug: "",
      //       comp_slug_err: false,
      //       faq_question: "",
      //       faq_question_err: false,
      //       faq_answer_detail: "",
      //       faq_answer_detail_err: false,
      //       additional_data: ""
      //       },
      //       {
      //       comp_slug: "",
      //       comp_slug_err: false,
      //       faq_question: "",
      //       faq_question_err: false,
      //       faq_answer_detail: "",
      //       faq_answer_detail_err: false,
      //       additional_data: ""
      //       }
      //   ]
      // }
      tab_list_errorArray: [
        {
          comp_slug_err: false,
          heading_err: false
        }
      ],
      tab_content_list_errorArray: [
        {
          comp_slug_err: false,
          faq_question_err: false,
          faq_answer_detail_err: false
        }
      ]
    }
  },
  created() {
    if (this.componentDetailsForEdit !== null) {
      console.log("componentDetailsForEdit!!!!!!!!!!!fieldJsonData", this.componentDetailsForEdit)
      this.fieldJsonData = this.componentDetailsForEdit
      console.log("this.fieldJsonData", this.fieldJsonData)
      for (let index = 0; index < this.fieldJsonData.tab_list.length; index++) {
        let obj = {
          comp_slug_err: false,
          heading_err: false
        }
        this.tab_list_errorArray.push(obj)
      }
      for (let index = 0; index < this.fieldJsonData.tab_content_list.length; index++) {
        let obj = {
          comp_slug_err: false,
          faq_question_err: false,
          faq_answer_detail_err: false
        }
        this.tab_content_list_errorArray.push(obj)
      }
    }
  },
  mounted () {
  },
  watch: {
    fieldJsonData: {
      handler () {
        console.log('fieldJsonData 123', this.fieldJsonData)
        if (this.fieldJsonData.description !== '') {
          this.desc_err = false
          this.isError = false
        }
        if (this.fieldJsonData.heading !== '') {
          this.heading_err = false
          this.isError = false
        }
        for (let index = 0; index < this.fieldJsonData.tab_list.length; index++) {
          for (let i = 0; i < this.tab_list_errorArray.length; i++) {
            if (index === i) {
              if (this.fieldJsonData.tab_list[index].comp_slug !== '') {
                this.tab_list_errorArray[i].comp_slug_err = false
                this.isError = false
              }
              if (this.fieldJsonData.tab_list[index].heading !== '') {
                this.tab_list_errorArray[i].heading_err = false
                this.isError = false
              }
            }
          }
        }
        for (let index = 0; index < this.fieldJsonData.tab_content_list.length; index++) {
          for (let i = 0; i < this.tab_content_list_errorArray.length; i++) {
            if (index === i) {
              if (this.fieldJsonData.tab_content_list[index].comp_slug !== '') {
                this.tab_content_list_errorArray[i].comp_slug_err = false
                this.isError = false
              }
              if (this.fieldJsonData.tab_content_list[index].faq_question !== '') {
                this.tab_content_list_errorArray[i].faq_question_err = false
                this.isError = false
              }
              if (this.fieldJsonData.tab_content_list[index].faq_answer_detail !== '') {
                this.tab_content_list_errorArray[i].faq_answer_detail_err = false
                this.isError = false
              }
            }
          }
        }
      },
      deep: true
    }
  },
  methods: {
    openCardListDescription (index) {
      this.tempCardDescriptionIndex = index
    },
    addTabListDetails () {
      this.fieldJsonData.tab_list.push({
        comp_slug: "",
        description: null,
        heading: ""
      })
      console.log("addddddd", this.fieldJsonData.tab_list);
      this.tab_list_errorArray.push(
        {
          comp_slug_err: false,
          heading_err: false
        }
      )
    },
    removeTabListDetails (index) {
      if (this.fieldJsonData.tab_list.length !== 1) {
        this.fieldJsonData.tab_list.splice(index, 1)
      }
      console.log("removeeeeeee", this.fieldJsonData.tab_list);
    },
    addTabContentDetails () {
      this.fieldJsonData.tab_content_list.push({
        comp_slug: "",
        faq_question: "",
        faq_answer_detail: "",
        additional_data: ""
      })
      console.log("addddddd", this.fieldJsonData.tab_content_list);
      this.tab_content_list_errorArray.push(
        {
          comp_slug_err: false,
          faq_question_err: false,
          faq_answer_detail_err: false
        }
      )
    },
    removeTabContentDetails (index) {
      if (this.fieldJsonData.tab_content_list.length !== 1) {
        this.fieldJsonData.tab_content_list.splice(index, 1)
      }
      console.log("removeeeeeee", this.fieldJsonData.tab_content_list);
    },
    saveData() {
      console.log("componentDetailsForEdit", this.componentDetailsForEdit)
      if (this.fieldJsonData.description === '') {
        this.desc_err = true
        this.isError = true
      }
      if (this.fieldJsonData.heading === '') {
        this.heading_err = true
        this.isError = true
      }
      for (let index = 0; index < this.fieldJsonData.tab_list.length; index++) {
        for (let i = 0; i < this.tab_list_errorArray.length; i++) {
            if (index === i) {
              if (this.fieldJsonData.tab_list[index].comp_slug === '') {
                this.tab_list_errorArray[i].comp_slug_err = true
                this.isError = true
              }
              if (this.fieldJsonData.tab_list[index].heading === '') {
                this.tab_list_errorArray[i].heading_err = true
                this.isError = true
              }
            }
        }
      }
      for (let index = 0; index < this.fieldJsonData.tab_content_list.length; index++) {
        for (let i = 0; i < this.tab_content_list_errorArray.length; i++) {
            if (index === i) {
              if (this.fieldJsonData.tab_content_list[index].comp_slug === '') {
                this.tab_content_list_errorArray[i].comp_slug_err = true
                this.isError = true
              }
              if (this.fieldJsonData.tab_content_list[index].faq_question === '') {
                this.tab_content_list_errorArray[i].faq_question_err = true
                this.isError = true
              }
              if (this.fieldJsonData.tab_content_list[index].faq_answer_detail === '') {
                this.tab_content_list_errorArray[i].faq_answer_detail_err = true
                this.isError = true
              }
            }
        }
      }
      if (this.isError === false) {
        // for (let index = 0; index < this.fieldJsonData.tab_list.length; index++) {
        //     delete this.fieldJsonData.tab_list[index].comp_slug_err
        //     delete this.fieldJsonData.tab_list[index].heading_err
        // }
        // for (let index = 0; index < this.fieldJsonData.tab_content_list.length; index++) {
        //     delete this.fieldJsonData.tab_content_list[index].comp_slug_err
        //     delete this.fieldJsonData.tab_content_list[index].faq_question_err
        //     delete this.fieldJsonData.tab_content_list[index].faq_answer_detail_err
        // }
        this.$emit('objData', this.fieldJsonData)
        this.componentDetailsForEdit = null
        let compIdImage = {
          imageUrl: this.componentImageUrl,
          id: this.componentId
        }
        // this.$emit('imageData', this.componentImageUrl)
        this.$emit('compIdImage', compIdImage)
        this.$root.$emit('closeComponentDialog', true)
        console.log("this.fieldJsonData............", this.fieldJsonData)
      }
    },
    closeDetails () {
    this.$root.$emit('closeComponentDialog', true)
    },
  },
  beforeDestroy () {
  }
}
</script>
<style scoped>
/* .list_top_card_btn {
  width: 163px !important;
  margin-right: 15px !important;
} */

::placeholder {
  font-size: 16px;
}
</style>